export enum rewardValueTypes {
    GET_REWARD_VALUE_LOADING = "@@rewardValue/GET_REWARD_VALUE_LOADING",
    GET_REWARD_VALUE_SUCCESS = "@@rewardValue/GET_REWARD_VALUE_SUCCESS",
    GET_REWARD_VALUE_ERROR = "@@rewardValue/GET_REWARD_VALUE_ERROR",
  
    CREATE_REWARD_VALUE_LOADING = "@@rewardValue/CREATE_REWARD_VALUE_LOADING",
    CREATE_REWARD_VALUE_SUCCESS = "@@rewardValue/CREATE_REWARD_VALUE_SUCCESS",
    CREATE_REWARD_VALUE_ERROR = "@@rewardValue/CREATE_REWARD_VALUE_ERROR",
}